import React from "react";

export default function Error() {
  return (
    <div className="text-center">
      <img className="mt-3 " width={"550px"}src="https://i.pinimg.com/originals/11/dc/96/11dc96d2e4daca3ea8ff6aa41299b5e1.gif"alt="error"/>
    </div>
  );
}